import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChipType } from '../../enum/chip-types';
import { Chip } from '../../model/chip.model';

@Component({
  selector: 'chip-filter',
  templateUrl: './chip-filter.component.html',
  styleUrls: ['./chip-filter.component.scss']
})
export class ChipFilterComponent<T> {
  @Input() items: Chip<T>[] = [];
  @Input() ChipType = ChipType.Filter;
  @Input() selectedIndex?: number = -1;
  @Output() selectedIndexChange = new EventEmitter<number>();
  @Output() selectedItem = new EventEmitter<Chip<T> | null>();

  constructor() { }

  filterChip(item: Chip<T>, event: any, idx: number) {
    this.selectedIndex = idx;
    this.selectedIndexChange.emit(this.selectedIndex);

    if (event as boolean) {
      this.selectedItem.emit(item);
    } else {
      this.selectedItem.emit(null);
    }
  }
}
